import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingVideo } from './types/Listing';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideo[]>('GET', `/api/v2/listing/${listingId}/videos`);
